<template>
  <div
    style="width: 100vw;
            height: 100vh;
            padding: 0px !important;
            margin: 0px !important;
            top: 62px !important;
            left: 0px !important;
            position: absolute;"
    :dir="$functions.currentLangDirection()"
  >
    <b-card
      class="alertList d-md-block"
      style="padding: 0 !important;overflow-x: hidden;"
      :dir="$functions.currentLangDirection()"
    >
      <b-card-body>
        <v-data-table
          :header-props="{ sortIcon: null }"
          :headers="headers"
          :items="desserts"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sort_desc"
          item-key="_id"
          class="elevation-1"
          :search="search"
          :custom-filter="filterPerfectMatch"
          mobile-breakpoint="0"
          loading
          :loading-text="$t('Loading')"
          disable-pagination
          style="font-size: 10px!important;"
          :hide-default-footer="true"
          :hide-default-header="true"
          height="calc(-50px + 100vh)"
        >

          <template
              v-slot:item="{ item, index }"
          >
            <tr
                :data-id="item._id"
                style="background: #fff;"
            >
              <td colspan="1">
                <div
                    class="row mt-0"
                    style="border-bottom: 1px solid rgb(219 219 219);"
                >
                  <div
                      class="col-8"
                      style="padding: 5px"
                  >
                    <v-icon
                        size="18"
                        color="#555"
                        style="padding-left: 3px;"
                    >mdi-alert-outline</v-icon>
                    <span style="color: #1ba1e3;">
                    {{ $t(item.categories) }}
                    </span>
                  </div>
                  <div
                      class="col-3"
                      style="padding: 5px;text-align: center;"
                  >
                    <span >
                    {{ item.Time}}
                      </span>
                    <span style="font-size: 0.8rem;color: #777;">
                      {{ item.Date}}
                    </span>
                  </div>
                </div>
                <div
                    class="row "
                    style="height: 50px;"
                >
                  <div
                      class="col-12"
                      style="padding: 5px"
                  >
                    <span style="font-size: 11px;color: gray;">
                      {{ item.imei }}
                    </span>
                    <span style="font-size: 0.8rem;">
                        {{ $t(item.title) }}
                      </span>
                  </div>
                </div>

              </td>

            </tr>
          </template>

          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="initialize"
            >
              Reset
            </v-btn>
          </template>
        </v-data-table>

      </b-card-body>
    </b-card>

  </div>
</template>

<script>
import {
  BLink, BButton, BCard, BCardText, BCardBody,
} from 'bootstrap-vue'
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import deviceService from '@/services/device.service'
import { i18n } from '@/main'
// eslint-disable-next-line import/extensions

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BLink, BButton, BCard, BCardText, BCardBody,
  },
  data() {
    return {
      categories: {
        1: 'Switch was opened', 2: 'Switch was closed', 10: 'Tracker is charging', 11: 'Tracker does not charge', 20: 'Vehicle moved', 21: 'Vehicle stopped',
      },
      search: '',
      sortBy: 'creationTime',
      sort_desc: true,
      desserts: [],
      items: [
        { title: 'Change the name of the car', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'Change the type of car', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'Change the sim', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'Send', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'دسته',
          align: 'start',
          sortable: false,
          value: 'title',
          width: '45px',
        },
        {
          text: 'عنوان',
          align: 'start',
          value: 'categories',
          width: '50%',
        },
        {
          text: 'وضعیت ارتباط',
          align: 'start',
          value: 'Time',
        },
      ]
    },
  },
  created() {
    //this.doFillAlarm(null)
  },
  methods: {
    getDeviceOnlineStatusCssClass(imei) {
      return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(index))
    },
    doFillAlarm(imei) {
      this.desserts = []
      const imeis = []

      if (imei !== null) {
        imeis.push(imei)
      } else {
        const BreakException = {}
        try {
          Vue.prototype.$devices.forEach((devices, index) => {
            imeis.push(devices.imei)
            if (index === 20) throw BreakException
          })
        } catch (e) {
          if (e !== BreakException) throw e
        }
      }

      deviceService.getAlarm({
        imeis,
        types: 0,
        fromDate: 0,
        toDate: 0,
        limit: 22,
        sortItems: [{
          name: 'creationTime',
          desc: true,
        }],
      })
        .then(
          resp => {
            if (resp.status === 'success') {
              if ('result' in resp) {
                for (const item in resp.result) {
                  if (resp.result[item].length > 0) {
                    resp.result[item].forEach((val, index) => {
                      // eslint-disable-next-line no-param-reassign
                      val.imei = item
                      val.title = this.getPopupInfo(item).title
                      val.categories = this.categories[val.type]
                      const event = new Date(val.creationTime * 1000)
                      val.Date = event.toLocaleDateString(i18n.messages[Vue.prototype.defaultLanguage]['lang-country'])
                      val.Time = `  ${event.toLocaleTimeString(i18n.messages[Vue.prototype.defaultLanguage]['lang-country'])}`
                      this.desserts.push(val)
                    })
                  }
                }
              }
            }
            // console.log(this.desserts)
          },
          error => {
            this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Message'),
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
          },
        )
    },
    filterPerfectMatch(value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search))
    },

    sinceFrom(unixTime) {
      if (unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    buildLogoUrl(category) {
      try {
        return require(`@/assets/images/pins/cars/${this.options[category].src}.png`)
      } catch (e) {
        return require('@/assets/images/pins/cars/car.png')
      }
    },
  },
}
</script>
<style>
[dir=rtl] .alertList{
  top: 50px;
  width: 100%;
}
[dir=rtl] .alertList {
  height: 100vh;
}
[dir=rtl] .alertList {
  z-index: 998;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
}
.alertList .card, .alertList .card-body {
  background: #f7f7f7;
}
[dir="rtl"] .alertList {
  height: calc(100% - 50px);
  top: 0px;
  z-index: 99;
}
.theme--light.v-pagination .v-pagination__item--active{
  font-weight: bold;
  color: #2077ff;
}
.alertList .v-data-table>.v-data-table__wrapper>table{
  border-collapse: separate!important;    border-spacing: 0 0.8em;    background: #f7f7f7;
}
.alertList{
  padding: 0 !important;
}
.alertList .card-body{
  padding: 0 !important;
}
</style>
